import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'


const CustomerLink = ({ customer }) => {
    return <Link to={'/customer/edit/' + customer.id}>{customer.firstName + ' ' + customer.lastName}</Link>
}

CustomerLink.propTypes = {
    customer: PropTypes.object,
}

export default CustomerLink



// WEBPACK FOOTER //
// ./src/modules/customer/component/CustomerLink.js